/// <amd-module name="Repos/Common/Util/Build" />
import { GitStatus } from "Repos/Common/Contracts/Git";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { decodeUri, IArtifactData } from "VSS/Platform/Util/Linking";

const vstfsUriPrefix = "VSTFS:";
const uriSeparator = "/";
const TeamBuildToolName = "BUILD";
const ArtifactTypeName = "BUILD";
const resultRoute = "ms.vss-build-web.ci-results-hub-route";

/*
    This will convert the targeturl for each git status to a public url
*/
export function processGitStatusArtifactUris(pageContext: IVssPageContext, defaultProjectName: string, statuses: GitStatus[]): GitStatus[] {
    if (!statuses) {
        return [];
    }

    for (const status of statuses) {
        let projectName: string | undefined = undefined;
        if (status.description && status.description[0] === "[") {
            const closingIndex = status.description.indexOf("]");
            if (closingIndex > 0) {
                projectName = status.description.substring(1, closingIndex);
            }
        }

        if (!projectName) {
            projectName = defaultProjectName;
        }

        status.targetUrl = convertArtifactUriToPublicBuildUrl(pageContext, status.targetUrl, projectName);
    }

    return statuses;
}

export function convertArtifactUriToPublicBuildUrl(pageContext: IVssPageContext, uri: string, projectName: string): string {
    if (uri && isBuildArtifactUri(uri)) {
        const artifactId: IArtifactData = decodeUri(uri);
        return getBuildUrl(pageContext, artifactId.id, projectName);
    }
    return uri;
}

export function getBuildUrl(pageContext: IVssPageContext, buildId: string, projectName: string) {
    const routeValues: { [key: string]: string } = {};
    if (projectName) {
        routeValues["project"] = projectName;
    }

    routeValues["buildId"] = buildId;
    return routeUrl(pageContext, resultRoute, routeValues);
}

function isBuildArtifactUri(url: string): boolean {
    url = url.trim().toUpperCase();

    const urlParts = url.split(uriSeparator, 6);
    const [prefix, , , tool, type, moniker] = urlParts;

    return prefix === vstfsUriPrefix && tool === TeamBuildToolName && type === ArtifactTypeName && !!moniker;
}
